import React from 'react';
import { Typography, Modal, Box, Button, Grid } from '@mui/material';
import { asyncPostUpdateAgedmentWeCallYou } from '../../../../services/weCallYouClient.service';

type Props = {
    openModalReAgedment: boolean;
    handleCloseModalReAgedment: (updateAgedmentWeCallYou?: any) => void;
    agedment: any;
};
const ModalUpdateWeCallYou = ({
    openModalReAgedment,
    handleCloseModalReAgedment,
    agedment,
}: Props) => {
    const updateAgedmentWeCallYou = async () => {
        const updateAgedmentWeCallYou = await asyncPostUpdateAgedmentWeCallYou(
            agedment
        );
        handleCloseModalReAgedment(updateAgedmentWeCallYou);
    };
    return (
        <Modal
            open={openModalReAgedment}
            onClose={handleCloseModalReAgedment}
            aria-labelledby="we-call-you-modal-title"
            aria-describedby="we-call-you-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 500,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: 4,
                }}
            >
                <div className="modal-title-icetex">
                    <Typography
                        id="we-call-you-modal-title"
                        variant="h6"
                        component="h2"
                    >
                        Editar agenda
                    </Typography>
                </div>
                <div className="modal-description-icetex">
                    <Typography
                        id="we-call-you-modal-description"
                        sx={{ mt: 2 }}
                    >
                        Usted ya tiene una llamada agendada ¿Desea actualizarla?
                    </Typography>
                </div>
                <div className="modal-actions-icetex">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Button
                                className="icetex-btn-secundary"
                                onClick={handleCloseModalReAgedment}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button
                                className="icetex-btn-primary"
                                onClick={updateAgedmentWeCallYou}
                            >
                                Actualizar
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Box>
        </Modal>
    );
};

export default ModalUpdateWeCallYou;
